import { Header } from "@/components/Header";
import { Hero } from "@/components/Hero";

const Index = () => {
  return (
    <div className="min-h-screen bg-background">
      <Header />
      <Hero />
      
      <footer className="border-t py-12 px-4 bg-muted/30">
        <div className="container mx-auto max-w-6xl">
          <div className="grid md:grid-cols-3 gap-8 text-center md:text-left mb-8">
            <div>
              <h3 className="font-semibold text-lg mb-3">Contact Us</h3>
              <p className="text-muted-foreground mb-2">Phone/SMS/WhatsApp: +1 858-815-6800</p>
              <p className="text-muted-foreground">Email: orders@aquaquote.com</p>
            </div>
            <div>
              <h3 className="font-semibold text-lg mb-3">About AquaQuote</h3>
              <p className="text-muted-foreground mb-2">12 years in business</p>
              <p className="text-muted-foreground">Headquartered in San Diego, CA</p>
              <p className="text-muted-foreground">Multiple warehouse locations</p>
            </div>
            <div>
              <h3 className="font-semibold text-lg mb-3">Industries We Serve</h3>
              <p className="text-muted-foreground text-sm leading-relaxed">
                Food & Beverage • Agriculture • Manufacturing • System Builders • Service & Maintenance • Water Treatment • Pharmaceutical
              </p>
            </div>
          </div>
          <div className="text-center pt-6 border-t border-border/40">
            <p className="text-sm text-muted-foreground">© {new Date().getFullYear()} AquaQuote. Industrial & Commercial RO Membranes and Pressure Vessels.</p>
          </div>
        </div>
      </footer>
    </div>
  );
};

export default Index;
